import "./styles/KycProgress.css";
import { SectionHeading1 } from "../../components/BasicComponents";
import useUserAuthentication from "../../hooks/useUserAuthentication";
import { useEffect, useState } from "react";
import { getUserToken } from "../../utils/userAuthenticate";
import instance from "../../axios";
import { useTranslation } from "react-i18next";
import "../../localisation/index"

const KycProgress = () => {
  const [kycData, setKycData] = useState(null);
  const [isError, setIsError] = useState(false);
  const {t} = useTranslation()

  useUserAuthentication();

  const getKycStatus = async () => {
    const url = "/kyc/status";
    const headers = {
      Authorization: getUserToken(),
    };

    try {
      const res = await instance.post(url, {}, { headers });

      if (res?.status === 200) {
        const resData = res.data;

        if (resData?.code === 401) {
          throw new Error(t("errors.authenticationError"));
        }
        if (resData?.code === 403) {
          throw new Error(t("errors.sessionError"));
        }

        // for any other error
        if (resData?.code !== 200) {
          throw new Error(t("errors.serverError"));
        }
        // console.log(resData);
        setKycData(resData.data);
      }
    } catch (error) {
      // console.log(error);
      setIsError(error.message);
    }
  };

  useEffect(() => {
    getKycStatus();
  }, []);

  return (
    <div className="kyc-progress-container">
      <div className="progress-status">
        {kycData?.dashboard_activated === true ? (
          <>
            <div className="status-heading">
              <SectionHeading1 weight="500" size="20px" lineheight="20px">
                {t("kycProgress.dashboard")}
              </SectionHeading1>
            </div>
            <p className="box-text">
              {t("kycProgress.secure")}
            </p>
          </>
        ) : (
          <>
            <div className="status-heading">
              <SectionHeading1 weight="500" size="20px" lineheight="20px">
                {t("kycProgress.registration")}
              </SectionHeading1>
              <img
                className="kyc-status__progress"
                src={require("../../assets/icons/pngs/work-in-progress.png")}
                alt="progress"
              />
            </div>
            <p className="box-text">
              {t("kycProgress.activation")}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default KycProgress;
